export const getMfeInitialPath = route => {
  const {
    fullPath: oldPathname,
    params: { merchant_id: merchantId, account_id: accountId }
  } = route

  const basePath = `/${merchantId}/${accountId}`
  const initalPath = oldPathname.replace(basePath, '')

  return initalPath
}
